import React, {useRef, type ReactNode} from 'react'
import {DefaultOptions, QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'

type TanStackProviderProps = {
  children: ReactNode
  isDev?: boolean
  tanStackConfig?: DefaultOptions
}

const defaultQueryConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
    retry: false,
  },
}

export const TanStackProvider = ({
  children,
  isDev = process.env.NODE_ENV === 'development',
  tanStackConfig = defaultQueryConfig,
}: TanStackProviderProps) => {
  const queryClientRef = useRef(new QueryClient({defaultOptions: tanStackConfig}))

  return (
    <QueryClientProvider client={queryClientRef.current}>
      {children}

      {isDev && <ReactQueryDevtools buttonPosition="bottom-left" />}
    </QueryClientProvider>
  )
}
